export default "__VITE_ASSET__tysLGtwp__"